import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200/70 bg-primary-900 text-primary-100">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">伦理影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              伦理影院是一个聚焦伦理题材影视剧的内容展示平台，汇集最新的伦理电影与电视剧，致力于为观众提供便捷的浏览、筛选与观影体验。
            </p>
            <p className="mt-4 text-xs text-primary-300">
              本站所有影片信息均为演示用途的虚构内容，播放功能为前端模拟展示，不接入任何真实流媒体服务。
            </p>
          </div>

          <div className="flex flex-wrap gap-10">
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50">快速导航</h4>
              <ul className="mt-4 space-y-2 text-sm text-primary-200">
                <li>
                  <Link to="/" className="transition-colors hover:text-accent-300">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category?type=movie" className="transition-colors hover:text-accent-300">
                    伦理电影
                  </Link>
                </li>
                <li>
                  <Link to="/category?type=tv" className="transition-colors hover:text-accent-300">
                    伦理电视剧
                  </Link>
                </li>
                <li>
                  <Link to="/search" className="transition-colors hover:text-accent-300">
                    搜索影片
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50">关于</h4>
              <ul className="mt-4 space-y-2 text-sm text-primary-200">
                <li>
                  <Link to="/about" className="transition-colors hover:text-accent-300">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="transition-colors hover:text-accent-300">
                    免责声明
                  </Link>
                </li>
                <li>
                  <a href="mailto:contact@ethcinema.example.com" className="transition-colors hover:text-accent-300">
                    contact@ethcinema.example.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 伦理影院 · 演示站点，仅供学习与展示使用</p>
          <p className="whitespace-nowrap">内容均为虚构 · 版权归各自权利人所有</p>
        </div>
      </div>
    </footer>
  );
}